import { safeRound } from '@utils/safeRound'

export function truncateToOneDecimalPlace(value: number) {
    if (value == null) {
        return 'N/A'
    }
    return safeRound(value, 1)
}
